var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SocialAuthBtn',{staticClass:"facebook-btn",attrs:{"img":_vm.logo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithFacebook'),"color":"#3b63be","tiny":_vm.tiny},on:{"click":_vm.fLogIn}})}
var staticRenderFns = []

export { render, staticRenderFns }